import { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import IssueIcon from '../../images/issue.svg';
import styles from './ErrorPage.module.scss';

interface iProps {
  errorMessage: string;
}

function ErrorPage({ errorMessage }: iProps): ReactElement {
  const location = useLocation();
  const errorM = 'We are having problems processing your request. You may need to start again.';
  const url = `${location.pathname.split('/').slice(0, -1).join('/')}`;
  return (
    <section className={styles.error}>
      <div className={styles.formBody}>
        <div className={styles.loader}>
          <div className={styles.loadContainer}>
            <span className={styles.cusH3}>Something went wrong.</span>
            <div className={styles.errorMessage}>
              <img src={IssueIcon} alt="Warning" className={styles.icon} />
              <div className={styles.alertText}>
                <p>{errorM}</p>
                {errorMessage && (
                  <>
                    <span>Error details:</span>
                    <br />
                    <span>{errorMessage}</span>
                  </>
                )}
                <p>
                  <a href={url} aria-label="Click to">
                    Continue
                  </a>
                </p>
              </div>
            </div>
            <div>
              <p className={styles.intro}>
                If you keep having problems, call us on
                {' '}
                <a href="tel:0392008111" aria-label="phone number">
                  (03) 9200 8111
                </a>
                {' '}
                or
                {' '}
                <a href="tel:1300369819" aria-label="phone number">
                  1300 369 819
                </a>
                {' '}
                (regional callers).
              </p>
              <p>We are available 8am to 6pm Monday to Friday (except public holidays).</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default ErrorPage;
